import { ReactNode } from 'react';

export const ContainerDefault = ({ children, classNames = '' }: { children: ReactNode, classNames?: string; }) => <main className={`px-4 py-8 md:px-8 lg:px-12 flex-1 ${classNames}`}> {children} </main>;
